import * as types from '../constants/mutation-types'
import * as dateUtils from '../utils/timeutils'

function setCurrentThread (state, id) {
  state.currentThreadID = id
  if (!state.threads[id]) {
    debugger
  }
}

export default {
  [types.SET_CONNECTED] (state, isConnected) {
    state.isConnected = isConnected
    if (isConnected) {
      state.isConnectFail = false
    } else {
      const threads = state.threads
      for (let threadId in threads) {
        if (threads.hasOwnProperty(threadId)) {
          threads[threadId].incomming = null
        }
      }
    }
  },

  [types.SET_CONNECT_FAIL] (state, isConnectFail) {
    state.isConnectFail = isConnectFail
    state.loadedInitData = false
  },

  [types.RETRY] (state) {
    state.isConnected = false
    state.isConnectFail = false
    state.isLoadingRoom = true
    state.isLoadingMessage = true
    state.loadInitData = false
    state.loadedInitData = false
  },

  [types.SET_USER_INFO] (state, data) {
    state.userInfo = data
  },

  [types.SET_LIST_ROOM] (state, playload) {
    const listRoom = playload.roomList
    if (state.threadIds.length === 0) {
      state.threads = listRoom.reduce( (total, item) => {
        const isOnline = item.userStatuses.some( item => item.status === 0)
        const lastLoginTime = item.userStatuses.length > 0 ? item.userStatuses[0].lastLoginTime : ''
        const lastMeReadTime = item.lastMeReadTime
        const usersMap = item.userStatuses.reduce(function (total, item) {
          total[item.userId] = item
          return total
        }, {})
        total[item.roomID] = {id: item.roomID, name: item.name, userStatuses: item.userStatuses, usersMap: usersMap,
          online: isOnline, messages: [], lastMessage: null, incomming: false, lastMeReadTime, lastLoginTime, totalMsg: 0}
        return total
      }, {})
      state.threadIds = listRoom.map( item => item.roomID )
      if (listRoom.length > 0 && state.userInfo.userType === 2) {
        setCurrentThread(state, listRoom[0].roomID)
      }
    } else {
      state.listResendMessage = []
      listRoom.forEach(item => {
        const isOnline = item.userStatuses.some( item => item.status === 0)
        const lastLoginTime = item.userStatuses.length > 0 ? item.userStatuses[0].lastLoginTime : ''
        const usersMap = item.userStatuses.reduce(function (total, item) {
          total[item.userId] = item
          return total
        }, {})

        const thread = state.threads[item.roomID]
        if (thread != null) {
          thread.online = isOnline
          thread.lastLoginTime = lastLoginTime
          thread.usersMap = usersMap
        } else {
          state.threads[item.roomID] = {id: item.roomID, name: item.name, userStatuses: item.userStatuses, usersMap: usersMap,
            online: isOnline, messages: [], lastMessage: null, incomming: false, lastLoginTime: lastLoginTime, totalMsg: 0}
        }
        if (thread.waitMessages && thread.waitMessages.length > 0) {
          thread.waitMessages.forEach(message => {
            state.listResendMessage.push({text: message.content, id: thread.id})
          })
        }
      })
    }
  },

  [types.SWITCH_THREAD] (state, id) {
    setCurrentThread(state, id)
  },

  [types.SET_UNREAD_THREAD] (state, roomId) {
    const thread = state.threads[roomId]
    if (thread) {
      thread.unreadCount = 0
    }
  },

  [types.RECEIVE_MESSAGE] (state, message) {
    addMessage(state, message)
    const thread = state.threads[message.roomId]
    if (thread.waitMessages && thread.waitMessages.length > 0) {
      thread.waitMessages.pop()
    }
  },

  [types.RECEIVE_HISTORY_MESSAGE] (state, payload) {
    const isChinese = state.lang === "CHT"
    if (payload.isAll) {
      state.loadedInitData = true
      state.messages = {}
      for (const property in state.threads) {
        const thread = state.threads[property]
        thread.messages = []
      }
      const length = payload.messages.length
      for (let i = 0; i < length; i++) {
        addMessage(state, payload.messages[i])
      }
    } else {
      const thread = state.threads[payload.roomId]
      if (!thread) {
        return
      }
      if (payload.messages.length > 0) {
        const historyMsg = createOldGroupMessageList(payload.messages, null, thread, state, isChinese).reverse()
        thread.messages = historyMsg.concat(thread.messages)
      } else {
        thread.loadend = true
      }
    }
  },

  [types.USER_ONLINE] (state, info) {
    const threads = state.threads
    for (const prop in threads) {
      if (threads.hasOwnProperty(prop)) {
        const thread = threads[prop]
        const user = thread.userStatuses.find(item => item.userId === info.userId)
        if (user !== undefined && user !== null) {
          user.status = info.status
          const isOnline = thread.userStatuses.some( item => item.status === 0)
          thread.online = isOnline
          thread.lastLoginTime = info.lastLoginTime
          if (!isOnline) {
            thread.incomming = null
          }
        }
      }
    }
  },

  [types.SET_USER_ID] (state, payload) {
    state.userInfo.userId = payload.userId
    state.userInfo.verified = payload.verified
  },

  [types.READ_MESSAGE] (state, action) {
    const thread = state.threads[action.roomId]
    if (thread) {
      const userStatuses = thread.userStatuses
      userStatuses.forEach(userStatus => {
        if (userStatus.userId === action.userId) {
          userStatus.lastReadTime = action.lastReadTime
        }
      })
      if (thread.lastMessage) {
        const isMe = thread.lastMessage.author === state.userInfo.userId
        if (isMe) {
          thread.lastMessageRead = thread.lastMessage
        }
      }
    }
  },

  [types.INCOMMING_MESSAGE] (state, action) {
    const thread = state.threads[action.roomId]
    if (thread) {
      thread.incomming = action.status === 1 ? action : null
    }
  },

  [types.SET_OPEN_CHAT] (state, show) {
    state.isOpenChat = show
  },

  [types.SET_LOADING_ROOM_DATA] (state, isLoading) {
    state.isLoadingRoom = isLoading
  },

  [types.SET_IS_LOADING_MESSAGE] (state, isLoading) {
    state.isLoadingMessage = isLoading
  },

  [types.SET_CURRENT_LANG] (state, lang) {
    state.lang = lang
  },

  [types.SET_THREAD_SWITCH] (state, val) {
    state.threadSwitch = val
  },

  [types.ADD_WAIT_MESSAGE] (state, message) {
    const currentThread = state.currentThreadID
      ? state.threads[state.currentThreadID]
      : {}
    if (currentThread.waitMessages === undefined) {
      currentThread.waitMessages = []
    }
    currentThread.waitMessages.push(message)
    currentThread.waitLastMessage = message
  },

  [types.SET_DRAG_MESSAGE] (state, payload) {
    const thread = state.threads[payload.id]
    if (thread) {
      thread.dragMessage = payload.text
    }
  },

  [types.SET_LOAD_INIT_DATA] (state, loadData) {
    state.loadInitData = loadData
  },

  [types.SET_STATUS_APP] (state, status) {
    state.statusApp = status
  },

  [types.FREE_WAIT_MESSAGES] (state, listResend) {
    listResend.forEach(message => {
      const thread = state.threads[message.id]
      if (thread) {
        thread.waitMessages = []
      }
    })
  }

}

function addMessage (state, message) {
  state.messages[message.id] = message
  const isChinese = state.lang === "CHT"
  const thread = state.threads[message.roomId]
  if (!thread) {
    return
  }
  thread.incomming = null
  thread.totalMsg++

  let prevousMessage = thread.lastMessage
  const isMe = message.author === state.userInfo.userId

  if (!thread.messages.some(id => id === message.id)) {
    if (prevousMessage === null) {
      const group = {}
      group.ids = [message.id]
      const isToday = dateUtils.isToday(message.time)
      group.time = isToday ? dateUtils.formatHourMinutes(message.time, isChinese) : dateUtils.formatDateHourMinutes(message.time, isChinese)
      group.me = isMe
      group.name = thread.usersMap[message.author] ? thread.usersMap[message.author].userName : ""
      thread.messages.push(group)
      message.first = true
      message.end = true
      prevousMessage = message
    } else {
      if (prevousMessage.author === message.author
        && dateUtils.getHours(prevousMessage.time) === dateUtils.getHours(message.time)
        && dateUtils.getMinutes(prevousMessage.time) === dateUtils.getMinutes(message.time)) {
        const lastGroup = thread.messages[thread.messages.length - 1]

        if (lastGroup.ids.length > 0) {
          const lastId = lastGroup.ids[lastGroup.ids.length - 1]
          state.messages[lastId].end = false
        }
        lastGroup.ids.push(message.id)
        message.first = false
        message.end = true
      } else {
        const group = {}
        group.ids = [message.id]
        group.me = isMe
        group.name = thread.usersMap[message.author] ? thread.usersMap[message.author].userName : ""
        const isToday = dateUtils.isToday(message.time)
        group.time = isToday ? dateUtils.formatHourMinutes(message.time, isChinese) : dateUtils.formatDateHourMinutes(message.time, isChinese)
        thread.messages.push(group)
        message.first = true
        message.end = true
      }
      prevousMessage = message
    }
    thread.lastMessage = message
  }

  const isRead = thread.lastMeReadTime ? dateUtils.isAfter(thread.lastMeReadTime, message.time) : false
  if (!isRead && !isMe) {
    if (!thread.unreadCount) {
      thread.unreadCount = 1
    } else {
      thread.unreadCount += 1
    }
  }
  const isUserInRoomRead = thread.userStatuses.length > 0 ? dateUtils.isAfter(thread.userStatuses[0].lastReadTime, message.time) : false
  if (isUserInRoomRead && isMe) {
    thread.lastMessageRead = message
  }
}

function createGroupMessageList (messages, state, isChinese) {
  let resultMsgs = []

  return resultMsgs
}

function createOldGroupMessageList (messages, lastMessage, thread, state, isChinese) {
  let resultMsgs = []
  let prevousMessage = lastMessage
  const userId = state.userInfo.userId

  for (let i = 0; i < messages.length; i++) {
    thread.totalMsg++
    const message = messages[i]
    if (!resultMsgs.some(id => id === message.id)) {
      if (prevousMessage === null) {
        const group = {}
        group.ids = [message.id]
        const isToday = dateUtils.isToday(message.time)
        group.time = isToday ? dateUtils.formatHourMinutes(message.time, isChinese) : dateUtils.formatDateHourMinutes(message.time, isChinese)
        group.me = message.author === userId
        group.name = thread.usersMap[message.author] ? thread.usersMap[message.author].userName : ""
        resultMsgs.push(group)
        prevousMessage = message
        message.first = true
        message.end = true
      } else {
        if (prevousMessage.author === message.author
          && dateUtils.getHours(prevousMessage.time) === dateUtils.getHours(message.time)
          && dateUtils.getMinutes(prevousMessage.time) === dateUtils.getMinutes(message.time)) {
          const lastGroup = resultMsgs[resultMsgs.length - 1]
          if (lastGroup.ids.length > 0) {
            const lastId = lastGroup.ids[0]
            state.messages[lastId].first = false
          }
          lastGroup.ids.unshift(message.id)
          message.first = true
          message.end = false
        } else {
          const group = {}
          group.ids = [message.id]
          group.me = message.author === userId
          group.name = thread.usersMap[message.author] ? thread.usersMap[message.author].userName : ""
          const isToday = dateUtils.isToday(message.time)
          group.time = isToday ? dateUtils.formatHourMinutes(message.time, isChinese) : dateUtils.formatDateHourMinutes(message.time, isChinese)
          resultMsgs.push(group)
          message.first = true
          message.end = true
        }
        prevousMessage = message
      }
    }
    state.messages[message.id] = message
  }
  return resultMsgs
}
